import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@/types/network";
import { StartQueryActionCreatorOptions } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@lib/redux/hooks";
import { eventsApi } from "@features/events/events-api";
import { selectUserWorkspaces } from "@features/workspaces/workspaces-selectors";
export const useGetWorkspacesEventsQuery = (query, options) => {
  const $ = _c(6);
  const workspaces = useAppSelector(selectUserWorkspaces);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== options || $[2] !== query || $[3] !== workspaces) {
    t0 = () => {
      if (dispatch && workspaces) {
        workspaces.forEach(workspace => {
          dispatch(eventsApi.endpoints.getWorkspaceEvents.initiate({
            idOrSlug: workspace.id,
            query
          }, options));
        });
      }
    };
    t1 = [dispatch, options, query, workspaces];
    $[0] = dispatch;
    $[1] = options;
    $[2] = query;
    $[3] = workspaces;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
};